import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod/v4'

import { dbEnv } from '@package/drizzle/env'
import { sdkEnv } from '@package/sdk/env'
import { utilsEnv } from '@helper/utils/env'

export function triggerEnv() {
  return createEnv({
    extends: [sdkEnv(), dbEnv(), utilsEnv()],
    server: {
      PAYLOAD_SECRET: z.string().min(1),
      TRIGGER_SECRET_KEY: z.string().min(1),
      NODE_ENV: z.enum(['development', 'production']).optional(),
    },
    clientPrefix: 'NEXT_PUBLIC',
    client: {
      NEXT_PUBLIC_PROD_ENV: z.enum(['development', 'production', 'staging']).optional(),
    },
    runtimeEnv: process.env,
    skipValidation:
      !!process.env.CI ||
      process.env.npm_lifecycle_event === 'lint' ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      typeof (globalThis as any).window !== 'undefined', // Skip in browser
  })
}
